import { render, staticRenderFns } from "./EditFailTransitTime.vue?vue&type=template&id=89563a28&"
import script from "./EditFailTransitTime.vue?vue&type=script&lang=js&"
export * from "./EditFailTransitTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports